var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import { components } from 'react-select';
import { cx } from '@emotion/css';
export function MultiValueRemove(props) {
    if (props.data.unclearableValue) {
        return null;
    }
    const { innerProps } = props, rest = __rest(props, ["innerProps"]);
    const className = cx(innerProps.className, 'Select-value-icon');
    const newProps = Object.assign(Object.assign({}, rest), { innerProps: Object.assign(Object.assign({}, innerProps), { className }) });
    return React.createElement(components.MultiValueRemove, Object.assign({}, newProps));
}
//# sourceMappingURL=MultiValueRemove.js.map